// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kFV1","toggle":"styles_toggle__3_YOv","preview":"styles_preview__1BMAf"};